module.exports = __webpack_public_path__ + "static/media/ps-help-video-en.e4ac1aaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/ps-help-video-en.png
// module id = 1469
// module chunks = 0